// Enhanced navigation with View Transitions API
export function setupViewTransitions() {
  // Check if View Transitions API is supported
  if (!document.startViewTransition) {
    console.log(
      "View Transitions API not supported, using standard navigation"
    );
    return;
  }

  // Intercept link clicks for smooth transitions
  document.addEventListener("click", (e) => {
    const target = e.target as HTMLElement;
    const link = target.closest("a[href]") as HTMLAnchorElement;

    if (!link || !shouldEnhanceNavigation(link)) {
      return;
    }

    e.preventDefault();

    // Perform view transition
    document.startViewTransition(() => {
      window.location.href = link.href;
    });
  });

  console.log("View Transitions enabled for enhanced navigation");
}

function shouldEnhanceNavigation(link: HTMLAnchorElement): boolean {
  const href = link.getAttribute("href");

  // Don't enhance if:
  // - External link
  if (link.hostname && link.hostname !== window.location.hostname) {
    return false;
  }

  // - Has target="_blank" or similar
  if (link.target && link.target !== "_self") {
    return false;
  }

  // - Is a hash link
  if (href?.startsWith("#")) {
    return false;
  }

  // - Has download attribute
  if (link.hasAttribute("download")) {
    return false;
  }

  // - Is a form submission or special action
  if (link.closest("form")) {
    return false;
  }

  return true;
}

// Optional: Add loading states for better UX
export function addNavigationLoadingStates() {
  let isNavigating = false;

  document.addEventListener("click", (e) => {
    const target = e.target as HTMLElement;
    const link = target.closest("a[href]") as HTMLAnchorElement;

    if (link && shouldEnhanceNavigation(link) && !isNavigating) {
      isNavigating = true;

      // Add loading class to clicked link
      link.classList.add("navigating");

      // Optional: Add global loading indicator
      document.body.style.cursor = "wait";

      // Reset after a timeout (fallback)
      setTimeout(() => {
        isNavigating = false;
        link.classList.remove("navigating");
        document.body.style.cursor = "";
      }, 5000);
    }
  });
}
